import * as Yup from "yup";

const getAdjustFeeSchema = () =>
  Yup.object().shape({
    platform_fees: Yup.array()
      .of(Yup.object().shape({
        currency_code: Yup.string()
          .label("Currency Code")
          .required(),
        amount_type: Yup.string(),
        amount: Yup.number()
          .label("Amount")
          .required(),
        enabled: Yup.boolean(),
        })
      )
      .label("Platform Fees")
      .required(),
    attachments: Yup.mixed()
      .label("Attachments")
      .optional(),
  });

export default getAdjustFeeSchema;
